"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _store_1 = __importDefault(require("@store")); // Component
var RegisterInLayout = function RegisterInLayout() {
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal[0];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal3[1];
    var _useGlobal4 = _store_1.default(function (state) {
        return state.regBundle;
    }, function (actions) {
        return actions.setRegBundle;
    }), setRegBundle = _useGlobal4[1];
    var _React$useState = react_1.default.useState(''), email = _React$useState[0], setEmail = _React$useState[1];
    var _React$useState2 = react_1.default.useState(''), firstName = _React$useState2[0], setFirstName = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(''), lastName = _React$useState3[0], setLastName = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(true), userAcceptedTerms = _React$useState4[0], setUserAcceptedTerms = _React$useState4[1];
    var toggleUserAcceptedTerms = function toggleUserAcceptedTerms() {
        return setUserAcceptedTerms(!userAcceptedTerms);
    };
    var _React$useState5 = react_1.default.useState(false), formValid = _React$useState5[0], setFormValid = _React$useState5[1];
    react_1.default.useEffect(function () {
        setRegBundle({
            email: email,
            firstName: firstName,
            lastName: lastName
        });
        setFormValid(userAcceptedTerms && firstName.length > 2 && lastName.length > 2 && /\S+@\S+\.\S+/.test(email));
    }, [email, firstName, lastName]);
    var register = function register() {
        setPanel('pricing');
        setVisibleDropdown('account');
    };
    return user ? /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null) : /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Background, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, null, /*#__PURE__*/ react_1.default.createElement(Form, null, /*#__PURE__*/ react_1.default.createElement(Column, null, /*#__PURE__*/ react_1.default.createElement(Header, null, /*#__PURE__*/ react_1.default.createElement(Eyebrow, null, "Join PRIOR"), /*#__PURE__*/ react_1.default.createElement(Headline, null, "Sign up for the latest journeys, inspiration, and intel from PRIOR.")), /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "privacyCheck",
        onChange: toggleUserAcceptedTerms,
        checked: userAcceptedTerms
    }, "I agree to PRIOR\u2019s ", /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/terms-of-use"
    }, "terms of use"), " and ", /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/privacy-policy",
        target: "_blank"
    }, "privacy policy"), ".")), /*#__PURE__*/ react_1.default.createElement(Column, null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: firstName,
        label: "First Name",
        name: "firstName",
        onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return setFirstName(value);
        },
        required: true,
        autoComplete: "off",
        noBorder: true
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: lastName,
        label: "Last Name",
        name: "lastName",
        onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return setLastName(value);
        },
        required: true,
        autoComplete: "off",
        noBorder: true
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        value: email,
        label: "Email Address",
        name: "email",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setEmail(value);
        },
        required: true,
        autoComplete: "off",
        noBorder: true
    })), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        type: "gold",
        size: "large",
        display: "flex",
        disabled: !formValid,
        onClick: function onClick() {
            return register();
        }
    }, "Join PRIOR")))))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__Wrapper",
    componentId: "sc-1827oyl-0"
})(["padding:32px 0px;", "{padding:40px 0px;}", "{padding:48px 0px;}", "{padding:64px 0px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Background = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__Background",
    componentId: "sc-1827oyl-1"
})(["background-color:", ";color:", ";"], _theme_1.palette.ink, _theme_1.palette.snow);
var Form = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__Form",
    componentId: "sc-1827oyl-2"
})(["display:flex;flex-direction:column;padding:64px 0px;@media only screen and (min-width:", "){padding:80px 0px;}@media only screen and (min-width:", "){flex-direction:row;justify-content:space-between;padding:96px 0px;}@media only screen and (min-width:", "){padding:128px 0px;}"], _theme_1.breakpoint.tablet, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop);
var Column = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__Column",
    componentId: "sc-1827oyl-3"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;width:100%;&:first-of-type{margin-bottom:32px;}color:", ";@media only screen and (min-width:", "){&:first-of-type{margin-bottom:40px;}}@media only screen and (min-width:", "){width:calc(50% - 20px);&:first-of-type{margin-bottom:0;}}@media only screen and (min-width:", "){width:calc(50% - 40px);}"], _theme_1.palette.snow, _theme_1.breakpoint.tablet, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop); // Header
var Header = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__Header",
    componentId: "sc-1827oyl-4"
})(["padding-bottom:24px;@media only screen and (min-width:", "){padding-bottom:16px;}@media only screen and (min-width:", "){padding-bottom:34px;}"], _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop);
var Eyebrow = styled_components_1.default.p.withConfig({
    displayName: "RegisterInLayout__Eyebrow",
    componentId: "sc-1827oyl-5"
})(["", ""], _theme_1.type.labelSmall);
var Headline = styled_components_1.default.h2.withConfig({
    displayName: "RegisterInLayout__Headline",
    componentId: "sc-1827oyl-6"
})(["", " padding-top:8px;@media only screen and (min-width:", "){padding-top:16px;}@media only screen and (min-width:", "){padding-top:17px;}@media only screen and (min-width:", "){padding-top:24px;}"], _theme_1.type.h2, _theme_1.breakpoint.tablet, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop); // Form
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "RegisterInLayout__ButtonWrapper",
    componentId: "sc-1827oyl-7"
})(["padding-top:8px;@media only screen and (min-width:", "){padding-top:16px;}"], _theme_1.breakpoint.desktop);
exports.default = RegisterInLayout;
